var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c(
              "div",
              { staticClass: "range_picker" },
              [
                _c("date-range-picker", {
                  ref: "picker",
                  attrs: {
                    startDate: _vm.startDate,
                    opens: "right",
                    ranges: _vm.ranges,
                    "locale-data": _vm.date_locale,
                  },
                  model: {
                    value: _vm.dateRange,
                    callback: function ($$v) {
                      _vm.dateRange = $$v
                    },
                    expression: "dateRange",
                  },
                }),
                _vm._v(" "),
                _c(
                  "vue-ladda",
                  {
                    attrs: {
                      "button-class": "btn btn-info",
                      "data-style": "zoom-in",
                      loading: _vm.loading,
                    },
                    on: { click: _vm.showStatistics },
                  },
                  [_vm._v("Показать статистику\n                        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.dataUploaded
                ? _c("div", { staticClass: "col-md-12 m-t-20" }, [
                    _c(
                      "table",
                      { staticClass: "table table-hover table-bordered" },
                      [
                        _c("thead", [
                          _c(
                            "tr",
                            [
                              _c("th"),
                              _vm._v(" "),
                              _vm._l(
                                _vm.table_columns,
                                function (column, index) {
                                  return _c(
                                    "th",
                                    { key: index, attrs: { colspan: "2" } },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(column.name) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c("th", { attrs: { colspan: "2" } }, [
                                _vm._v("Итого"),
                              ]),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.dates, function (date, index2) {
                          return _c(
                            "tbody",
                            { key: index2 },
                            [
                              _vm.main_total[date]
                                ? [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-center date_row",
                                          attrs: { colspan: "20" },
                                        },
                                        [_vm._v(_vm._s(date))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.table_rows,
                                      function (row, index3) {
                                        return _c(
                                          "tr",
                                          {
                                            key: index3,
                                            class: _vm.checkTotalLine(row.city),
                                          },
                                          [
                                            _c("td", [
                                              _vm._v(_vm._s(row.name)),
                                            ]),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.table_columns,
                                              function (col, index4) {
                                                return [
                                                  _c("td", { key: index4 }, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.printData(
                                                          _vm.main_total,
                                                          date,
                                                          row,
                                                          index4,
                                                          "qnty"
                                                        )
                                                      ) +
                                                        "\n                                            "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.printData(
                                                          _vm.main_total,
                                                          date,
                                                          row,
                                                          index4,
                                                          "cost"
                                                        )
                                                      ) +
                                                        "\n                                            "
                                                    ),
                                                  ]),
                                                ]
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "light_gray" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.total_line_figures[
                                                        date
                                                      ][row.source][row.city]
                                                        .qnty
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "light_gray" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.total_line_figures[
                                                        date
                                                      ][row.source][row.city]
                                                        .cost
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "tr",
                                      { staticClass: "total_line" },
                                      [
                                        _c("td", [_vm._v("Итого общее")]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.table_columns,
                                          function (site, index6) {
                                            return [
                                              _c(
                                                "td",
                                                [
                                                  _c(
                                                    "v-popover",
                                                    {
                                                      attrs: {
                                                        placement: "left",
                                                        trigger: "hover",
                                                      },
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.printTotal(
                                                              date,
                                                              index6,
                                                              "qnty"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "template",
                                                        { slot: "popover" },
                                                        [
                                                          _c("div", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                `${_vm.printTooltip(
                                                                  date,
                                                                  "qnty",
                                                                  index6
                                                                )}`
                                                              ),
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  _c(
                                                    "v-popover",
                                                    {
                                                      attrs: {
                                                        placement: "left",
                                                        trigger: "hover",
                                                      },
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.printTotal(
                                                              date,
                                                              index6,
                                                              "cost"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "template",
                                                        { slot: "popover" },
                                                        [
                                                          _c("div", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                `${_vm.printTooltip(
                                                                  date,
                                                                  "cost",
                                                                  index6
                                                                )}`
                                                              ),
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "v-popover",
                                              {
                                                attrs: {
                                                  placement: "left",
                                                  trigger: "hover",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.printGrandTotal(
                                                        date,
                                                        "qnty"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "template",
                                                  { slot: "popover" },
                                                  [
                                                    _c("div", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          `${_vm.printTooltip(
                                                            date,
                                                            "qnty",
                                                            "total"
                                                          )}`
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "v-popover",
                                              {
                                                attrs: {
                                                  placement: "left",
                                                  trigger: "hover",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.printGrandTotal(
                                                        date,
                                                        "cost"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "template",
                                                  { slot: "popover" },
                                                  [
                                                    _c("div", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          `${_vm.printTooltip(
                                                            date,
                                                            "cost",
                                                            "total"
                                                          )}`
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Статистика заявок")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }